import billingState from "@/modules/billingStatus/view/BillingStatus.vue";

export const BillingStateRoutes = [
    {
        path: '/billing/status',
        component: billingState,
    }
]